import { BliksyIcon, cn } from '@bliks-io/ui';

interface BliksyChatButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * Floating circular button to open the Bliksy chat panel
 * Positioned at the bottom-left of the screen, above the bottom bar
 */
export function BliksyChatButton({ isOpen, onToggle, className }: BliksyChatButtonProps) {
  // Don't show button when panel is open
  if (isOpen) return null;

  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'absolute bottom-4 left-4 z-(--z-sticky)',
        'flex h-14 w-14 items-center justify-center overflow-hidden',
        'rounded-full',
        'transition-transform duration-200 hover:scale-110',
        'focus:outline-hidden focus:ring-2 focus:ring-success focus:ring-offset-2',
        className
      )}
      aria-label="Open Bliksy chat"
    >
      <BliksyIcon size={56} animated />
    </button>
  );
}
